export default __webpack_public_path__ + "static/media/sch-over1.a47483a9.svg";